var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.quantity >= 1)?_c('cart-filled',{staticClass:"cart-filled",attrs:{"manyProducts":_vm.cartProducts.length >= 4,"loading":_vm.loading},on:{"openConfirm":_vm.openConfirm,"buy":()=>{_vm.$emit('buy')},"createQuotation":()=>{_vm.$emit('createQuotation')}}}):_c('cart-empty',{staticClass:"cart-empty"})
}
var staticRenderFns = []

export { render, staticRenderFns }